import React from 'react';
import {AsyncSelectEvent, IFilter} from '../Table';
import {
  IOptionValue,
  Select,
  SelectControllerTheme,
  SelectDropdownTheme,
} from '../../Select/Select';
import { useAppSelector } from 'src/redux';
import selectors from 'src/redux/selectors';
import useAsyncSelect, { UseAsyncSelectProps } from 'src/hooks/useAsyncSelect';
import useSearchQueryParams from 'src/hooks/useSearchQueryParams';
import { SUPPORT_FRONTEND_PARAM_NAME } from 'src/utils/constans/global';
import getDataForTree from "src/utils/helpers/getDataForTree";

interface IProps {
  item: IFilter;
  onChange: (
    value: IOptionValue,
    event?: React.MouseEvent,
    asyncData?: AsyncSelectEvent
  ) => void;
  propsValue: string;
  asyncFilter: UseAsyncSelectProps;
  fieldName: string;
}

const AsyncSelectConfig = ({
   item,
   onChange,
   propsValue,
   asyncFilter,
   fieldName,
}: IProps) => {
  const { params } = useSearchQueryParams({});
  let controllerTheme = SelectControllerTheme.FROM_TABLE;
  if (item.config?.controllerTheme) {
    controllerTheme = item.config.controllerTheme;
  }
  const dropdownTheme = SelectDropdownTheme.FROM_TABLE;
  const asyncSelectData = useAppSelector(selectors.getAsyncSelectData);
  const { searchHandler, hasMore, fetchNextPage } = useAsyncSelect({...asyncFilter, isInfinite:true});
  const preSelectedTitle =
    params[asyncFilter.storeFieldName + SUPPORT_FRONTEND_PARAM_NAME];
  const options = asyncSelectData[fieldName]?.fullData || [];
  const optionsWithAdditional = [...options];
  if (
    propsValue && !options.find((item) => item.id == propsValue) &&
    !asyncSelectData[fieldName]?.isSearched
    && !getDataForTree(options).find(item => item.id === propsValue)
  ) {
    optionsWithAdditional.push({
      name: preSelectedTitle,
      id: propsValue,
      children: [],
      preselected: true
    });
  }
  const changeHandler = (value: IOptionValue, event?: React.MouseEvent) => {
    const optionsFromTree = getDataForTree(options)
    const name = optionsFromTree.find((item) => item.id == value)?.metadata?.name
    onChange(value, event, {
      key: asyncFilter.storeFieldName + SUPPORT_FRONTEND_PARAM_NAME,
      value: name as string,
    });
  };
  return (
    <div>
      <Select
        controllerTheme={controllerTheme}
        dropdownTheme={dropdownTheme}
        hasSearch
        hasMore={hasMore}
        fetchNextPage={fetchNextPage}
        onSearch={searchHandler}
        onChange={changeHandler}
        propsValue={propsValue}
        disablePortal={false}
        stylesConfig={{
          isWidth100: true,
        }}
        isNoValueAllText
        recursiveSelect={{
          titleFieldName: 'name',
          data: optionsWithAdditional
        }}
        {...item.config}
      />
    </div>
  );
};

export default AsyncSelectConfig;
